
import { API_URL, getAuthHeaders } from './config';

export const podService = {
    createMockupTask: async (productId: number, files: any[], variantIds?: number[]) => {
        const res = await fetch(`${API_URL}/pod/mockup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify({
                productId,
                variantIds,
                files
            })
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Failed to create mockup task");
        }
        return res.json();
    },
    getMockupTaskStatus: async (taskKey: string) => {
        const res = await fetch(`${API_URL}/pod/mockup-status?task_key=${taskKey}`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Failed to get mockup task status");
        return res.json();
    },
    syncCatalog: async (shopId: string) => {
        const res = await fetch(`${API_URL}/pod/sync-catalog`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify({ shopId })
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Failed to sync catalog");
        }
        return res.json();
    },
    getProducts: async (shopId: string) => {
        const res = await fetch(`${API_URL}/marketplace/shops/${shopId}/products`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Failed to fetch products");
        return res.json();
    },
    getStats: async () => {
        const res = await fetch(`${API_URL}/pod/stats`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Failed to fetch stats");
        return res.json();
    },
    getSyncProduct: async (id: string) => {
        const res = await fetch(`${API_URL}/pod/sync-products/${id}`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Failed to get sync product");
        }
        return res.json();
    },
    calculateShipping: async (recipient: any, items: any[]) => {
        const res = await fetch(`${API_URL}/pod/shipping`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify({ recipient, items })
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Failed to calculate shipping");
        }
        return res.json();
    },
    deleteProduct: async (id: string) => {
        const res = await fetch(`${API_URL}/pod/products/${id}`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Failed to delete product");
        return res.json();
    },
    updateProduct: async (id: string, data: any) => {
        const res = await fetch(`${API_URL}/pod/products/${id}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) throw new Error("Failed to update product");
        return res.json();
    }
};
